export function capitalize(str) {
  if (typeof str !== "string" || !str) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isInThePast(date) {
  const today = new Date();

  // 👇️ OPTIONAL!
  // This line sets the hour of the current date to midnight
  // so the comparison only returns `true` if the passed in date
  // is at least yesterday
  today.setHours(0, 0, 0, 0);

  return date < today;
}

export const getSiteDomain = ({ site }) => {
  try {
    return new URL(site.url).origin
      .replace(/^http(s?):\/\//, "")
      .replace(/\/$/, "");
  } catch (e) {
    return site.url.replace(/^http(s?):\/\//, "").replace(/\/$/, "");
  }
};

export const formatNumber = (amount) => {
  if (amount === undefined || amount === null) {
    return "";
  }
  return amount.toLocaleString();
};

// Check if member is a recent member, i.e. created in last 24 hours
export function isRecentMember({ member }) {
  if (!member?.created_at) {
    return false;
  }

  const now = new Date();
  const created = new Date(member.created_at);
  const diff = now.getTime() - created.getTime();
  const diffHours = Math.round(diff / (1000 * 60 * 60));

  return diffHours < 24;
}

export const safeCallback = (callback, arg1, arg2, arg3) => {
  if (!callback) {
    return;
  }

  if (arg3 !== undefined) {
    callback(arg1, arg2, arg3);
    return;
  }
  if (arg2 !== undefined) {
    callback(arg1, arg2);
    return;
  }
  callback(arg1);
};

export const runningOnBrowser = typeof window !== "undefined";

export const isBot =
  (runningOnBrowser && !("onscroll" in window)) ||
  (typeof navigator !== "undefined" &&
    /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent));

export const supportsIntersectionObserver =
  runningOnBrowser && "IntersectionObserver" in window;

export const supportsClassList =
  runningOnBrowser && "classList" in document.createElement("p");

export const supportsCreateImageBitmap =
  runningOnBrowser && "createImageBitmap" in window;

export const supportsFetch = runningOnBrowser && "fetch" in window;

export const isHiDpi = runningOnBrowser && window.devicePixelRatio > 1;

export function plainText(html) {
  // Remove HTML tags, non-breaking spaces, and line breaks
  return html
    .replace(/<\/?[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/<br\s*[/]?>/gi, "\n")
    .trim();
}

export const removeSpaces = (values) => {
  Object.keys(values).forEach((key) =>
    typeof values[key] === "string"
      ? (values[key] = values[key]?.trim()?.replace(/  +/g, " "))
      : values[key],
  );
  return values;
};

export const getSrno = (currentPage, pageSize, index) => {
  return (currentPage === 1 ? 0 : (currentPage - 1) * pageSize) + index + 1;
};

export const TrimText = (value, size = 40) => {
  return value !== undefined && value.length > size
    ? value.slice(0, size) + "..."
    : value;
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return "NA"; // Return 'NA' if the string is empty or undefined
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const displayPermissions = (permissions) => {
  let data = Object.keys(permissions);
  return data.join(" , ");
};

// Permission utility function
export const hasPermission = (permissionKey, user) => {
  if (!user) return false;

  if (user.role === "super_admin") return true;

  const permissions = user.permissions || user.permission || {};
  return permissions[permissionKey] === true;
};

// Check if user has any CMS-related permission
export const hasAnyCmsPermission = (user) => {
  if (!user) return false;

  if (user.role === "super_admin") return true;

  const permissions = user.permissions || user.permission || {};
  const cmsPermissions = [
    "FAQ Management",
    "About Us",
    "Community Guidelines",
    "Privacy Policy",
    "Terms & Conditions",
    "Event Guidelines",
    "Refund Policies",
    "Marketing & Notifications",
  ];

  return cmsPermissions.some((perm) => permissions[perm] === true);
};

// Get first available route based on permissions
export const getFirstAvailableRoute = (user) => {
  if (!user) return "/dashboard";

  // If super_admin, always go to dashboard
  if (user.role === "super_admin") return "/dashboard";

  const permissions = user.permissions || user.permission || {};

  // Permission to route mapping (in order of priority)
  const permissionRouteMap = [
    { permission: "Dashboard", route: "/dashboard" },
    { permission: "Admin Management", route: "/subadmin" },
    { permission: "User Management", route: "/users" },
    { permission: "Organizer Management", route: "/organizer" },
    { permission: "Vendor Management", route: "/vendor" },
    { permission: "Petsitter Management", route: "/petsitter" },
    { permission: "Subscription Management", route: "/subscription" },
    { permission: "Entities Management", route: "/global" },
    { permission: "Reviews Management", route: "/reviews" },
    { permission: "Payments & Payouts", route: "/paymentpayout" },
    { permission: "User Reports", route: "/userreport" },
    { permission: "Category Management", route: "/category" },
    { permission: "Pet Spots Management", route: "/petspots" },
    { permission: "Support & Feedback", route: "/usersupportfeedback" },
    { permission: "FAQ Management", route: "/cms/faq-management" },
    { permission: "About Us", route: "/cms/about-us" },
    { permission: "Community Guidelines", route: "/cms/community" },
    { permission: "Privacy Policy", route: "/cms/privacypolicy" },
    { permission: "Terms & Conditions", route: "/cms/termsconditions" },
    { permission: "Event Guidelines", route: "/cms/eventguidelines" },
    { permission: "Refund Policies", route: "/cms/refundpolicies" },
    {
      permission: "Marketing & Notifications",
      route: "/cms/notification-templates",
    },
    { permission: "Marketing Management", route: "/marketing" },
  ];

  // Find first permission that is true
  for (const { permission, route } of permissionRouteMap) {
    if (permissions[permission] === true) {
      return route;
    }
  }

  // Default fallback
  return "/dashboard";
};

export const trimFormValues = (values) => {
  const trimmed = {};
  Object.keys(values).forEach((key) => {
    const value = values[key];
    if (typeof value === "string") {
      trimmed[key] = value.trim();
    } else {
      trimmed[key] = value;
    }
  });
  return trimmed;
};
